"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _linkModule = _interopRequireDefault(require("./link.module.css"));

var _arrowRightIcon = _interopRequireDefault(require("../icons/arrowRightIcon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _toolTip = _interopRequireDefault(require("../toolTip/toolTip"));

var _popover = _interopRequireDefault(require("../popover/popover"));

var _printIcon = _interopRequireDefault(require("../icons/printIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var mapVariantToClassName = function mapVariantToClassName(variant) {
  if (variant === 'tertiary') {
    return _linkModule.default["link-tertiary"];
  }

  if (variant === 'primary') {
    return _linkModule.default["link-primary"];
  }

  if (variant === 'dropdown') {
    return _linkModule.default["link-strong"];
  }

  if (variant === "print") {
    return _linkModule.default["link-print"];
  }

  return "";
};

var mapArrowDirectionToClassName = function mapArrowDirectionToClassName(arrowDirection) {
  if (arrowDirection === "left") {
    return _linkModule.default["btn-arrow-left"];
  }

  if (arrowDirection === "right") {
    return _linkModule.default["btn-arrow-right"];
  }

  return "";
};

var Link = function Link(props) {
  var id = props.id,
      expanded = props.expanded,
      expandable = props.expandable,
      variant = props.variant,
      label = props.label,
      onClick = props.onClick,
      disabled = props.disabled,
      arrowDirection = props.arrowDirection,
      type = props.type,
      info = props.info,
      popover = props.popover,
      reversedArrow = props.reversedArrow,
      _props$linkTestID = props.linkTestID,
      linkTestID = _props$linkTestID === void 0 ? 'linkTestID' : _props$linkTestID;
  var variantToClassNameMap = mapVariantToClassName(variant);
  var arrowDirectionMapping = mapArrowDirectionToClassName(arrowDirection);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovered = _useState2[0],
      setIsHovered = _useState2[1];

  var onMouseEnter = function onMouseEnter() {
    return setIsHovered(true);
  };

  var onMouseLeave = function onMouseLeave() {
    return setIsHovered(false);
  };

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isPopoverOpen = _useState4[0],
      setPopoverOn = _useState4[1];

  var onPopoverLeave = function onPopoverLeave() {
    return setPopoverOn(false);
  };

  var openPopover = function openPopover() {
    return setPopoverOn(!isPopoverOpen);
  };

  return _react.default.createElement("div", {
    id: id ? id : null,
    className: _linkModule.default["btn-wrapper"],
    onMouseEnter: info ? function () {
      return onMouseEnter();
    } : null,
    onMouseLeave: info ? function () {
      return onMouseLeave();
    } : null,
    "data-testid": linkTestID
  }, _react.default.createElement("button", {
    id: id ? "".concat(id, "_link_button") : null,
    type: type ? type : "button",
    disabled: disabled,
    style: info && disabled ? {
      pointerEvents: "none"
    } : {},
    onClick: popover ? openPopover : onClick,
    lang: "aragUilib",
    className: (0, _classnames.default)(_themeModule.default.arag, _linkModule.default.btn, variantToClassNameMap, arrowDirectionMapping, expandable ? _linkModule.default["expandable"] : "")
  }, variant === "print" ? _react.default.createElement("span", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, _react.default.createElement(_printIcon.default, {
    className: (0, _classnames.default)(_linkModule.default["icon-print"])
  }), " ") : null, label, arrowDirectionMapping && _react.default.createElement(_arrowRightIcon.default, {
    id: id ? "".concat(id, "_arrow") : null,
    className: (0, _classnames.default)(_linkModule.default["icon-arrow"], reversedArrow ? _linkModule.default["reversed-arrow"] : "", expanded ? _linkModule.default["expanded"] : "")
  })), isHovered && _react.default.createElement(_toolTip.default, {
    id: id ? "".concat(id, "_link_tooltip") : null,
    text: info
  }), popover && isPopoverOpen && _react.default.createElement(_popover.default, {
    id: id ? "".concat(id, "_link_popover") : null,
    popover: popover,
    onPopoverLeave: onPopoverLeave
  }));
};

Link.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** The type of the link. */
  type: _propTypes.default.oneOf(['submit', 'button']),

  /** The variant of the link component */
  variant: _propTypes.default.oneOf(['tertiary', 'primary', 'dropdown']),

  /** String text of the label */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,

  /** Callback invoked  on click*/
  onClick: _propTypes.default.func,

  /** Boolean indicating if the component is disabled */
  disabled: _propTypes.default.bool,

  /** The direction of the arrow */
  arrowDirection: _propTypes.default.oneOf(['left', 'right']),

  /** Boolean indicating that the  link button is expandable*/
  expandable: _propTypes.default.bool,

  /** Boolean indicated that the link button is expanded.When used expandable prop must be set to true */
  expanded: _propTypes.default.bool,

  /** String text ToolTip */
  info: _propTypes.default.string,

  /** Object that must contain all the required props of the selected popover component*/
  popover: _propTypes.default.object,

  /** Boolean indicating if the Arrow is reversed or not */
  reversedArrow: _propTypes.default.bool,

  /** Test ID for Link*/
  linkTestID: _propTypes.default.string
};
var _default = Link;
exports.default = _default;